import { render, staticRenderFns } from "./ProductFeedChooser.vue?vue&type=template&id=8c1cdbbc&lang=pug&"
import script from "./ProductFeedChooser.vue?vue&type=script&lang=js&"
export * from "./ProductFeedChooser.vue?vue&type=script&lang=js&"
import style0 from "./ProductFeedChooser.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports